export enum FamilySituation {
    Single = 'SINGLE',
    SingleWithChildren = 'SINGLE_WITH_CHILDREN',
    WithPartner = 'WITH_PARTNER',
    WithPartnerAndChildren = 'WITH_PARTNER_AND_CHILDREN',
    LivingWithParents = 'LIVING_WITH_PARENTS',
    LivingWithAcquaintance = 'LIVING_WITH_ACQUAINTANCE',
}
